module.exports = __webpack_public_path__ + "img/con1.987a7846.png";